import { render, staticRenderFns } from "./SignalsureDashboard.vue?vue&type=template&id=0088a002&scoped=true&"
import script from "./SignalsureDashboard.vue?vue&type=script&lang=js&"
export * from "./SignalsureDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SignalsureDashboard.vue?vue&type=style&index=0&id=0088a002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0088a002",
  null
  
)

export default component.exports